var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 13.4593C12.7402 13.4593 13.3402 12.8594 13.3402 12.1193C13.3402 11.3792 12.7402 10.7793 12.0002 10.7793C11.2601 10.7793 10.6602 11.3792 10.6602 12.1193C10.6602 12.8594 11.2601 13.4593 12.0002 13.4593Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 8.43976C12.7402 8.43976 13.3402 7.83983 13.3402 7.09977C13.3402 6.3597 12.7402 5.75977 12.0002 5.75977C11.2601 5.75977 10.6602 6.3597 10.6602 7.09977C10.6602 7.83983 11.2601 8.43976 12.0002 8.43976Z",
    fill: "#BBBBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 18.47C12.7402 18.47 13.3402 17.8701 13.3402 17.13C13.3402 16.39 12.7402 15.79 12.0002 15.79C11.2601 15.79 10.6602 16.39 10.6602 17.13C10.6602 17.8701 11.2601 18.47 12.0002 18.47Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.aac322a50861270bc8e0a6324ebcf528.svg";
export { ForwardRef as ReactComponent };